// HEXA theme is locked to dark. The old light/dark toggle was removed by user
// request; scoped overrides (e.g. `.hexa-force-light` in the Proposal Builder)
// continue to work independently via CSS.
import React, { createContext, useContext, useEffect } from "react";

const ThemeContext = createContext({ theme: "dark", setTheme: () => {}, toggleTheme: () => {} });

export function ThemeProvider({ children }) {
  useEffect(() => {
    if (typeof document === "undefined") return;
    document.documentElement.setAttribute("data-theme", "dark");
    document.documentElement.style.colorScheme = "dark";
    // Drop any legacy stored preference so the OS stays dark on refresh.
    try { localStorage.removeItem("hexa-theme"); } catch { /* ignore */ }
  }, []);

  const noop = () => {};
  return (
    <ThemeContext.Provider value={{ theme: "dark", setTheme: noop, toggleTheme: noop }}>
      {children}
    </ThemeContext.Provider>
  );
}

export const useTheme = () => useContext(ThemeContext);
